module.exports = __webpack_public_path__ + "img/customer-a-012.c4c6cc9a.png";